<template>
  <CContainer class="min-vh-100 d-flex align-items-center">
    <CRow class="w-100 justify-content-center">
      <CCol md="6" sm="8">
        <CCard class="mx-4 mb-0">
          <CCardBody class="p-4">
            <form @submit.prevent="createAccount">
                <h1>Registrierung</h1>
                <p class="text-muted">Konto Erstellen</p>
                <CInput
                  placeholder="Name"
                  autocomplete="name"
                  v-model="name"
                  invalid-feedback="Bitte tragen Sie Ihren Namen ein."
                  :is-valid="validator"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                    <CInput
                      placeholder="E-Mail"
                      autocomplete="email"
                      prepend="@"
                      v-model="email"
                      v-validate="'required|email'"
                      name="email"
                      invalid-feedback="Bitte tragen Sie Ihre E-Mail ein."
                      :is-valid="email"
                    />
                <CInput
                  placeholder="Passwort"
                  type="password"
                  autocomplete="new-password"
                  v-model="password"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CInput
                  placeholder="Passwort wiederholen"
                  type="password"
                  autocomplete="new-password"
                  class="mb-4"
                  v-model="password_repeat"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CButton @click="createAccount" color="success" block>Erstellen</CButton>
            </form>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>

    import { mapActions } from 'vuex'
    export default {
        name: 'Register',
        data: ()=>({
            name: '',
            email: '',
            password: '',
            password_repeat: ''
        }),

        methods: {
            ...mapActions('auth', [
                'register'
            ]),

            createAccount() {
                let data = {
                    name: this.name,
                    email: this.email,
                    password: this.password,
                    password_confirmation: this.password_repeat
                }

                this.register(data)
          },

            validator(val) {
                return val ? val.length >= 3 : false
            }
      }
    }
</script>
